// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffUploader_ValidateTlisQueryVariables = Types.Exact<{
  filter: Types.TakeoffLineItemFilter;
  versionId: Types.Scalars['ID']['input'];
}>;


export type TakeoffUploader_ValidateTlisQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean }> } };


export const TakeoffUploader_ValidateTlisDocument = gql`
    query TakeoffUploader_ValidateTlis($filter: TakeoffLineItemFilter!, $versionId: ID!) {
  takeoffLineItemsPage(filter: $filter, versionId: $versionId) {
    items {
      id
      active
    }
  }
}
    `;

/**
 * __useTakeoffUploader_ValidateTlisQuery__
 *
 * To run a query within a React component, call `useTakeoffUploader_ValidateTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffUploader_ValidateTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffUploader_ValidateTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useTakeoffUploader_ValidateTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables> & ({ variables: TakeoffUploader_ValidateTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>(TakeoffUploader_ValidateTlisDocument, options);
      }
export function useTakeoffUploader_ValidateTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>(TakeoffUploader_ValidateTlisDocument, options);
        }
export function useTakeoffUploader_ValidateTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>(TakeoffUploader_ValidateTlisDocument, options);
        }
export type TakeoffUploader_ValidateTlisQueryHookResult = ReturnType<typeof useTakeoffUploader_ValidateTlisQuery>;
export type TakeoffUploader_ValidateTlisLazyQueryHookResult = ReturnType<typeof useTakeoffUploader_ValidateTlisLazyQuery>;
export type TakeoffUploader_ValidateTlisSuspenseQueryHookResult = ReturnType<typeof useTakeoffUploader_ValidateTlisSuspenseQuery>;
export type TakeoffUploader_ValidateTlisQueryResult = Apollo.QueryResult<TakeoffUploader_ValidateTlisQuery, TakeoffUploader_ValidateTlisQueryVariables>;